module.exports = __webpack_public_path__ + "static/img/ten_bg.affe9a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/riff/ten_bg.png
// module id = Eb7u
// module chunks = 12